export default {
    LIVE_STATE: {
        /** 审核中，待审核 */
        REVIEWING: 1,
        /** 审核驳回 */
        REVIEW_UNPASS: 2,
        /** 通过 */
        REVIEW_PASS: 3,
        /** 预告 */
        NOTICE: 4,
        /** 直播中 */
        LIVING: 5,
        /** 直播结束 */
        LIVE_END: 6,
        /** 回放中 */
        PLAY_BACK: 7,
        /** 过期 */
        EXPIRE: 8,
        /** 关闭 */
        CLOSE: 9,
        /** 下线 */
        OFFLINE: 10,
    },
};
